/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { NotebookSessionStatus } from '../models/NotebookSessionStatus';

export class NotebookSession {
  /**
  * The unique identifier of the session
  */
  'id': string;
  /**
  * The notebook this session belongs to
  */
  'notebookId': string;
  /**
  * The Spark engine this session is attached to
  */
  'engineId': string;
  /**
  * The user who started the session
  */
  'userId': string;
  'status': NotebookSessionStatus;
  /**
  * The Jupyter kernel ID
  */
  'kernelId'?: string;
  /**
  * When the session was started
  */
  'createdAt': Date;
  /**
  * Last cell execution time
  */
  'lastActivityAt': Date;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "id",
      "baseName": "id",
      "type": "string",
      "format": ""
    },
    {
      "name": "notebookId",
      "baseName": "notebookId",
      "type": "string",
      "format": ""
    },
    {
      "name": "engineId",
      "baseName": "engineId",
      "type": "string",
      "format": ""
    },
    {
      "name": "userId",
      "baseName": "userId",
      "type": "string",
      "format": ""
    },
    {
      "name": "status",
      "baseName": "status",
      "type": "NotebookSessionStatus",
      "format": ""
    },
    {
      "name": "kernelId",
      "baseName": "kernelId",
      "type": "string",
      "format": ""
    },
    {
      "name": "createdAt",
      "baseName": "createdAt",
      "type": "Date",
      "format": "date-time"
    },
    {
      "name": "lastActivityAt",
      "baseName": "lastActivityAt",
      "type": "Date",
      "format": "date-time"
    }  ];

  static getAttributeTypeMap() {
    return NotebookSession.attributeTypeMap;
  }

  public constructor() {
  }
}



